import React, { Component } from 'react';
import './styles.css';
import Body from './Body';
import BodyLeft from './BodyLeft';
import BodyLeftRow from './BodyLeftRow';
import BodyLeftRowLabel from './BodyLeftRowLabel';
import BodyRight from './BodyRight';
import BodyRightLabel from './BodyRightLabel';
import Footer from './Footer';
import FooterLabel from './FooterLabel';
import FooterValue from './FooterValue';

class SalesTestLayout extends Component {
	render() {
		const { children } = this.props;
		return <div className="sales-test-layout">{children}</div>;
	}
}

Object.assign(SalesTestLayout, {
	Body,
	BodyLeft,
	BodyLeftRow,
	BodyLeftRowLabel,
	BodyRight,
	BodyRightLabel,
	Footer,
	FooterLabel,
	FooterValue
});

export default SalesTestLayout;
